import {ACTIONS} from '../actions/Actions'

const users = (state = {}, action) => { 
    switch  (action.type){
    case ACTIONS.users.index.statuses.completed: {
	return Object.assign({}, state, {list: action.data})
    }
    case ACTIONS.users.current.statuses.completed: {
	return Object.assign({}, state, {current: {authorized: true, info: action.data}})
    }
    case ACTIONS.users.current.statuses.unauthorized: {
	return Object.assign({}, state, {current:  {authorized: false, info:{}}})
    }
    case ACTIONS.users.signin.statuses.completed: {
	return Object.assign({}, state, {current: {authorized: true, info: action.data}})
    }
    case ACTIONS.users.signout.statuses.completed: {
	return Object.assign({}, state, {current: {authorized: false}})
    }
    case ACTIONS.users.signin.statuses.error: {
	return Object.assign({}, state, {current: {authorized: false, auth: action.data}})
    }
    default:
	return state
    }
}
export default users
